import React, { useState } from "react";
import * as m from "../../lib/model";
import { ChevronDown, ChevronRight, Plus, Trash2, Mail, Phone, HandCoins, FileSignature } from "lucide-react";

const pct = (a, b) => (b > 0 ? Math.min(100, Math.round((a / b) * 100)) : 0);
const fmtD = (iso) => new Date(iso + "T00:00:00").toLocaleDateString(undefined, { month: "short", day: "numeric" });

export const TimelineWeek = ({ week, target, pace, open, onToggle, onChange, kind = "raise" }) => {
  const [draft, setDraft] = useState("");
  const st = week.stats || {};
  const done = week.tasks.filter((t) => t.done).length;
  const cls = `tl-week ${week.current ? "current" : ""} ${week.past ? "past" : ""} ${open ? "open" : ""}`;
  const behind = target > 0 && week.past && st.cumRaised < pace;

  const setTasks = (tasks) => onChange({ ...week, tasks });
  const add = () => { if (!draft.trim()) return; setTasks([...week.tasks, { id: `${Date.now()}`, text: draft.trim(), done: false }]); setDraft(""); };

  return (
    <div className={cls} data-testid={`tl-week-${week.n}`}>
      <div className="tl-week-head" onClick={onToggle} role="button">
        <span className="tl-wk">{open ? <ChevronDown size={13} /> : <ChevronRight size={13} />}Wk {week.n}</span>
        <span className="tl-dates">{fmtD(week.start)} – {fmtD(week.end)}{week.current && <em className="tl-now">This week</em>}</span>
        <input className="tl-title" value={week.title} onClick={(e) => e.stopPropagation()} onChange={(e) => onChange({ ...week, title: e.target.value })} placeholder="Week focus…" data-testid={`tl-week-title-${week.n}`} style={{ display: open ? undefined : "none" }} />
        {!open && <span className="tl-title tl-title-static" data-testid={`tl-week-title-text-${week.n}`}>{week.title || <i style={{ color: "var(--text3)", fontWeight: 400 }}>Week focus…</i>}</span>}
        <span className="tl-stats" title={kind === "debt" ? "Emails · calls · term sheets received · commitments (auto from lender pipeline)" : "Emails · calls · new commitments (auto from pipeline)"}>
          <i><Mail size={11} />{st.emails || 0}</i><i><Phone size={11} />{st.calls || 0}</i>{kind === "debt" && <i><FileSignature size={11} />{st.termSheets || 0}</i>}<i><HandCoins size={11} />{st.commits || 0}</i>
        </span>
        <span className="tl-done">{done}/{week.tasks.length}</span>
        <div className="tl-pace" title={`Raised ${m.fmt$(st.cumRaised || 0)} · pace ${m.fmt$(pace)}`}>
          <span className={`tl-pace-fill ${behind ? "behind" : ""}`} style={{ width: `${pct(st.cumRaised || 0, target)}%` }} />
          {target > 0 && <span className="tl-pace-mark" style={{ left: `${pct(pace, target)}%` }} />}
        </div>
        <span className={`tl-raised ${behind ? "neg" : ""}`}>{m.fmt$(st.cumRaised || 0)}</span>
      </div>
      {open && (
        <div className="tl-tasks" data-testid={`tl-tasks-${week.n}`}>
          {week.tasks.length === 0 && <div className="cm-empty">No activities planned this week yet.</div>}
          {week.tasks.map((t) => (
            <label key={t.id} className={`tl-task ${t.done ? "done" : ""}`} data-testid={`tl-task-${t.id}`}>
              <input type="checkbox" checked={!!t.done} onChange={() => setTasks(week.tasks.map((x) => (x.id === t.id ? { ...x, done: !x.done } : x)))} data-testid={`tl-task-check-${t.id}`} />
              <span>{t.text}</span>
              <button className="tl-x" onClick={(e) => { e.preventDefault(); setTasks(week.tasks.filter((x) => x.id !== t.id)); }} title="Remove" data-testid={`tl-task-remove-${t.id}`}><Trash2 size={11} /></button>
            </label>
          ))}
          <div className="tl-add">
            <input className="inp" value={draft} placeholder="Add an activity for this week…" onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} data-testid={`tl-task-input-${week.n}`} />
            <button className="btn" onClick={add} data-testid={`tl-task-add-${week.n}`}><Plus size={12} />Add</button>
          </div>
          <div className="tl-week-foot">
            This week from the pipeline: {st.emails || 0} email(s) sent · {st.calls || 0} call(s) logged · {kind === "debt" ? `${st.termSheets || 0} term sheet(s) received · ` : ""}{st.commits || 0} {kind === "debt" ? "lender commitment(s)" : "new commitment(s)"} worth {m.fmt$(st.raised || 0)}{st.roomCommits ? ` · ${st.roomCommits} via Deal Room` : ""}
          </div>
        </div>
      )}
    </div>
  );
};
